import { FC, PropsWithChildren, useEffect } from 'react';

import { useContextSelector } from 'use-context-selector';

import { SectionContext } from '../Section.context';

type SectionCollapseProps = PropsWithChildren<{
  className?: string;
}>;

export const SectionCollapse: FC<SectionCollapseProps> = ({
  children,
  className,
}) => {
  const setState = useContextSelector(
    SectionContext,
    ({ setState }) => setState
  );

  useEffect(() => {
    setState((prev) => ({ ...prev, collapsible: true }));
    return () => {
      setState((prev) => ({ ...prev, collapsible: false }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={className} slot="content">
      {children}
    </div>
  );
};
